export default __webpack_public_path__ + "static/Visual_Vocab_Landscape_H264-ae3c02ef5b43fd22b106da38507ccfb5.mp4";